
import { Vue, Component } from 'vue-property-decorator';
import VoteList from '../components/VoteList.vue';
import { Popup, Toast } from 'vant';
import { getRule } from '../api';
import { namespace, State, Mutation } from 'vuex-class';

const fengShangModule = namespace('fengShang');

Vue.use(Popup);
@Component({
  components: {
    VoteList,
  },
})
export default class List extends Vue {
  @fengShangModule.Mutation setWorkType!: (num: number) => void;
  ruleShow = false;
  ruleData = '';
  list: any = [
    { id: 1, text: '个人赛' },
    { id: 2, text: '团体赛' },
  ];
  id: number = 1;
  async showRule() {
    if (!this.ruleData) {
      Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      const res: any = await getRule();
      Toast.clear();
      this.ruleData = res.data;
      this.ruleShow = true;
    } else {
      this.ruleShow = true;
    }
  }
  getList(id: number) {
    this.id = id;
    this.setWorkType(id);
  }
}
